<template>
    <div class="content-wrapper">
        <div class="row">
            <app-breadcrumb :page-title="$t('generated_combos')" :icon="'list'" class="col-6"/>
            <div class="col-6 d-flex flex-row justify-content-end">
                <label for="copy_switch" class="mr-2">{{ $t('copy') }}</label>
                <app-input id="copy_switch" type="switch" :label="$t('Switch')" v-model="copyActive"/>
            </div> 
        </div>
        <div class="open-combos combos mb-primary">
            <div class="card position-relative card-with-shadow py-primary border-0" v-for="(data, comboIndex) in generated_data" :key="data.id" :class="comboIndex > 0 ? 'mt-4' : ''">
                <app-overlay-loader v-if="preloader"/>
                <div v-else class="row align-items-center">
                    <div class="col-12">
                        <div class="combo-header d-flex flex-row">
                            <div class="col-3">
                                <label for="name" class="col-form-label">
                                    {{ $t('name') }}
                                </label>
                                <app-input 
                                    name="name"
                                    type="text"
                                    v-model="data.name"
                                    :disabled="true"
                                    :placeholder="$t('name')"
                                    :required="true"/>
                            </div>
                            <div class="col-2">
                                <label for="status" class="col-form-label">
                                    {{ $t('status') }}
                                </label>
                                <app-input 
                                    name="status"
                                    type="select"
                                    v-model="defaultStatus"
                                    listValueField='name'
                                    :disabled="true"
                                    :placeholder="$t('status')"
                                    :list="[{id: 'GENERATED', name: $t('generated')}]"
                                    :required="true"/>
                            </div>
                            <div class="col-2">
                                <label for="min_games" class="col-form-label">
                                    {{ $t('min_games') }}
                                </label>
                                <app-input 
                                    name="min_games"
                                    type="select"
                                    v-model="data.min_games"
                                    listValueField='value'
                                    :disabled="true"
                                    :placeholder="$t('min_games')"
                                    :list="[{id: data.min_games, value: (data.min_games == 0 ? $t('auto') : data.min_games)}]"
                                    :required="true"/>
                            </div>
                            <div class="col-2">
                                <label for="max_games" class="col-form-label">
                                    {{ $t('max_games') }}
                                </label>
                                <app-input 
                                    name="max_games"
                                    type="select"
                                    v-model="data.max_games"
                                    listValueField='value'
                                    :disabled="true"
                                    :placeholder="$t('max_games')"
                                    :list="[{id: data.max_games, value: (data.max_games == 0 ? $t('auto') : data.max_games)}]"
                                    :required="true"/>
                            </div>
                            <div class="col-2">
                                <label for="min_combos" class="col-form-label">
                                    {{ $t('min_combos') }}
                                </label>
                                <app-input 
                                    name="min_combos"
                                    type="select"
                                    v-model="data.min_combos"
                                    listValueField='value'
                                    :disabled="true"
                                    :placeholder="$t('min_combos')"
                                    :list="[{id: data.min_combos, value: (data.min_combos == 0 ? $t('auto') : data.min_combos)}]"
                                    :required="true"/>
                            </div>
                            <div class="col-1">
                                <label for="download" class="col-form-label" style="visibility: hidden;">
                                    {{ $t('download') }}
                                </label>
                                <button type="button" class="btn btn-outline-primary mr-2" @click="downloadCombo(data.download_id)">{{ $t('download') }}</button>
                            </div>
                        </div>
                        <div class="combo-subheader d-flex flex-row mt-4 pb-3">
                            <div class="col-1">
                                {{ $t('time') }}
                            </div>
                            <div class="col-1">
                                {{ $t('sport') }}
                            </div>
                            <div class="col-2">
                                {{ $t('league') }}
                            </div>
                            <div class="col-2">
                                {{ $t('name') }}
                            </div>
                            <div class="col-1">
                                {{ $t('market') }}
                            </div>
                            <div class="col-1">
                                {{ $t('sub_market') }}
                            </div>
                            <div class="col-1 text-center">
                                {{ $t('line') }}
                            </div>
                            <div class="col-1 text-center">
                                {{ $t('odds') }}
                            </div>
                            <div class="col-1 text-center">
                                {{ $t('result') }}
                            </div>
                            <div class="col-1 text-center">
                                {{ $t('info') }}
                            </div>
                        </div>

                        <div class="combo-group" v-for="(combo, index) in data.combos" :key="index" :class="index > 0 ? 'mt-4' : ''">
                            <div class="combo-separator">
                                <div class="col-9">
                                    Combo {{ (parseInt(combo.id) + 1) }}
                                </div>
                                <div class="col-1 text-center">
                                    {{ combo.odds.toFixed(2) }}
                                </div>
                                <div class="col-1">
                                </div>
                                <div class="col-1">
                                    <div @click="deleteCombo(data.id, combo.id)" style="cursor: pointer; text-align: right; margin-right: 15px">
                                        {{ $t('delete') }}
                                    </div>
                                </div>
                            </div>
                            <Container :data-index="index" class="combo-body" :drag-class="'combo-while-dragging'" :group-name="data.id.toString()" :lock-axis="'y'" :get-child-payload="(itemIndex) => getChildPayload(index, itemIndex)" @drop="onDrop(comboIndex, combo.id, $event)">
                                <Draggable v-for="combo_game in combo.games" :key="combo_game.id" :class="combo_game.result" :tag="{value: 'div'}">
                                    <div class="w-100 d-flex flex-row" >
                                        <div class="col-1">
                                            <app-input 
                                                name="id"
                                                type="hidden"
                                                v-model="combo_game.id"
                                                :required="true"/>
                                            {{ combo_game.event_start_time }}
                                        </div>
                                        <div class="col-1">
                                            {{ $t(combo_game.sport) }}
                                        </div>
                                        <div class="col-2">
                                            {{ combo_game.league }}
                                        </div>
                                        <div class="col-2">
                                            {{ combo_game.name }}
                                        </div>
                                        <div class="col-1">
                                            {{ $t(combo_game.market) }}
                                        </div>
                                        <div class="col-1">
                                            {{ $t(combo_game.submarket) }}
                                        </div>
                                        <div class="col-1">
                                            <app-input 
                                                v-if="combo_game.market != 'wdw'"
                                                name="line"
                                                type="text"
                                                v-model="combo_game.line"
                                                :placeholder="$t('line')"
                                                :required="true"
                                                @change="saveRow(combo_game)"/>
                                        </div>
                                        <div class="col-1">
                                            <app-input 
                                                name="odds"
                                                type="text"
                                                v-model="combo_game.odds"
                                                :placeholder="$t('odds')"
                                                :required="true"
                                                @change="saveRow(combo_game)"/>
                                        </div>
                                        <div class="col-1">
                                            <app-input 
                                                type="select"
                                                v-model="combo_game.result"
                                                listValueField='name'
                                                :list="resultList"
                                                :placeholder="$t('result')"
                                                :required="true"
                                                @change="saveResult(combo_game.id, combo_game.game_id, combo_game.result)"
                                                />
                                        </div>
                                        <div class="col-1 justify-content-around">
                                            <div>
                                                {{ combo_game.combo_amount }}
                                            </div>
                                            <div @click="deleteRow(combo_game.id)" style="cursor: pointer;">
                                                {{ $t('delete') }}
                                            </div>
                                        </div>
                                    </div>
                                </Draggable>
                            </Container>
                        </div>
                        <div class="combo-group mt-4">
                            <div class="combo-separator">
                                <div class="col-12">
                                    {{ $t('new_combo') }}
                                </div>
                            </div>
                            <Container :data-index="9999" class="combo-body" :drag-class="'combo-while-dragging'" :group-name="data.id.toString()" :lock-axis="'y'" :get-child-payload="(itemIndex) => getChildPayload(9999, itemIndex)" @drop="onDrop(comboIndex, 9999, $event)">
                                <div class="text-center py-4" style="color: #888">{{ $t('drop_any_game_here') }}</div>
                            </Container>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {FormMixin} from "../../../../core/mixins/form/FormMixin";
    import * as actions from "../../../Config/ApiUrl";
    import { Container, Draggable } from "vue-dndrop";
    export default {
        name: "openCombos",
        components: { Container, Draggable },
        mixins: [FormMixin],
        data() {
            return {
                preloader: false,
                copyActive: false,
                defaultStatus: 'GENERATED',
                generated_data: [],
                comboAmountList: [],
                sportsList: [
                    {id: 'football', name: this.$t('football')},
                    {id: 'basketball', name: this.$t('basketball')},
                    {id: 'tennis', name: this.$t('tennis')}
                ],
                marketList: [
                    {id: 'wdw', name: this.$t('wdw')},
                    {id: 'asian', name: this.$t('asian_handicap')},
                    {id: 'totals', name: this.$t('totals')}
                ],
                submarketList: [
                    {id: 'home', name: this.$t('home')},
                    {id: 'away', name: this.$t('away')},
                    {id: 'draw', name: this.$t('draw')},
                    {id: 'over', name: this.$t('over')},
                    {id: 'under', name: this.$t('under')}
                ],
                resultList: [
                    {id: 'win', name: this.$t('win')},
                    {id: 'halfwin', name: this.$t('half_win')},
                    {id: 'refund', name: this.$t('refund_void')},
                    {id: 'halfloss', name: this.$t('half_loss')},
                    {id: 'loss', name: this.$t('loss')}
                ]
            }
        },
        created() {
            this.data(true);
        },
        methods: {
            data(preload) {
                if (preload){
                    this.preloader = true;
                }
                let url = actions.GENERATED_COMBOS_LIST;
                this.axiosGet(url).then(response => {
                    this.generated_data = response.data;
                }).catch(({response}) => {
                }).finally(()=>{
                    this.preloader = false;
                });
            },
            saveResult(combo_row_id, combo_game_id, result){
                var formData = new FormData();
                formData.append('combo_row_id', combo_row_id);
                formData.append('game_id', combo_game_id);
                formData.append('result', result);

                this.axiosPost({
                    url: actions.COMBOS_SAVE_RESULT,
                    data: formData,
                }).then(response => {
                    if (response.data.status == 1){
                        this.$toastr.s(this.$t('result_saved'));
                        this.data(false);
                    } else if (response.data.status == 0){
                        this.$toastr.e(this.$t(response.data.message));
                    }
                });
            },
            getChildPayload (groupIndex, index) {
                return {
                    groupIndex: groupIndex,
                    index: index,
                }
            },
            onDrop(comboIndex, newGroupIndex, dropResult) {
                const { removedIndex, addedIndex, payload, element } = dropResult;
                var oldGroupIndex = payload.groupIndex;
                var oldElementIndex = payload.index;

                if (addedIndex !== null){
                    //console.log('element from ' + oldGroupIndex + '/' + oldElementIndex);
                    //console.log('dropped to ' + newGroupIndex + '/' + addedIndex);
                    var selectedCombo = this.generated_data[comboIndex];
                    var oldGroup = selectedCombo.combos[oldGroupIndex].games;

                    if (newGroupIndex == 9999){
                        newGroupIndex = parseInt(Object.keys(selectedCombo.combos).pop()) + 1;
                        selectedCombo.combos[newGroupIndex] = {
                            'id': newGroupIndex,
                            'odds': 0,
                            'games': [],
                        };
                    }

                    //console.log('dropped to ' + newGroupIndex + '/' + addedIndex);

                    var newGroup = selectedCombo.combos[newGroupIndex].games;

                    var itemToAdd = null;

                    if (oldGroupIndex !== null) {
                        console.log(this.copyActive);
                        if (this.copyActive){
                            itemToAdd = Object.assign({}, oldGroup[oldElementIndex]);
                            itemToAdd.id = 0;
                        } else {
                            itemToAdd = oldGroup.splice(oldElementIndex, 1)[0];
                        }
                    }

                    if (newGroupIndex !== null && itemToAdd != null) {
                        newGroup.splice(addedIndex, 0, itemToAdd);
                    }

                    if (oldGroupIndex !== null && newGroupIndex !== null && itemToAdd != null) {
                        this.save(selectedCombo);
                    }
                }
            },
            beforeSubmit(){
                this.preloader = true;
            },
            save(comboData) {
                var formData = new FormData();
                formData.append('data', JSON.stringify(comboData));
                this.axiosPost({
                    url: actions.COMBOS_GENERATED_SAVE,
                    data: formData,
                }).then(response => {
                    if (response.data.status == 1){
                        this.$toastr.s(this.$t('changes_saved'));
                        this.data(false);
                    } else if (response.data.status == 0){
                        this.$toastr.e(this.$t(response.data.message));
                    }
                });
            }, 
            deleteCombo(userComboId, comboIndex) {
                var formData = new FormData();
                formData.append('user_combo_id', userComboId);
                formData.append('user_combo_index', comboIndex);
                this.axiosPost({
                    url: actions.COMBOS_GENERATED_DELETE_SINGLE,
                    data: formData,
                }).then(response => {
                    if (response.data.status == 1){
                        this.$toastr.s(this.$t('combo_removed'));
                        this.data();
                    } else if (response.data.status == 0){
                        this.$toastr.e(this.$t(response.data.message));
                    }
                });
            },
            deleteRow(comboRowId) {
                var formData = new FormData();
                formData.append('combo_row_id', comboRowId);
                this.axiosPost({
                    url: actions.COMBOS_GENERATED_DELETE_ITEM,
                    data: formData,
                }).then(response => {
                    if (response.data.status == 1){
                        this.$toastr.s(this.$t('row_removed'));
                        this.data(false);
                    } else if (response.data.status == 0){
                        this.$toastr.e(this.$t(response.data.message));
                    }
                });
            },
            saveRow(combo) {
                var formData = new FormData();
                for (const [key, value] of Object.entries(combo)) {
                    formData.append(key, value);
                }
                this.axiosPost({
                    url: actions.COMBOS_GENERATED_SAVE_ITEM,
                    data: formData,
                }).then(response => {
                    if (response.data.status == 1){
                        this.$toastr.s(this.$t('row_updated'));
                        this.data(false);
                    } else if (response.data.status == 0){
                        this.$toastr.e(this.$t(response.data.message));
                    }
                });
            },
            downloadCombo(url) {
                window.open('/combo/export/' + url, '_blank').focus();
            },
            afterSuccess(res) {
                this.$toastr.s(res.data.message);
                window.location.reload();
            },
            afterFinalResponse() {
                this.preloader = false;
            },
            afterError(res) {
                this.$toastr.e(res.data.message);
            },
        }
    }
</script>